import styled from 'styled-components';
import type { WorkHoursInterval } from '../../common/business-hours-types';
import { useTimeFormatter } from '../utils/date-time-format';

type ScheduleWorkHoursProps = { hours: WorkHoursInterval[] };

export function ScheduleWorkHours({ hours }: ScheduleWorkHoursProps) {
  const formatTime = useTimeFormatter();

  return (
    <Container>
      {(hours || []).map(([from, until], i) => (
        <Item key={`${i}-${from.getTime()}`}>
          {formatTime(from)} - {formatTime(until)}
        </Item>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const Item = styled.div`
  white-space: nowrap;
`;
